import { PaymentMethod } from '@/data/catalog/offer/interfaces';
import type { CheckoutFlowValues } from '@/packages/courses/pages/checkout/hooks/useCheckoutWizard';
import { CheckoutStepIds } from '@/packages/courses/pages/checkout/types';

const nextStepById: Record<
  CheckoutStepIds,
  CheckoutStepIds | Record<PaymentMethod, CheckoutStepIds> | null
> = {
  [CheckoutStepIds.CustomerInfo]: CheckoutStepIds.PaymentMethod,
  [CheckoutStepIds.PaymentMethod]: {
    [PaymentMethod.Pix]: CheckoutStepIds.DataConfirmation,
    [PaymentMethod.BankSlip]: CheckoutStepIds.DataConfirmation,
    [PaymentMethod.Card]: CheckoutStepIds.CreditCardDetails,
  },
  [CheckoutStepIds.CreditCardDetails]: CheckoutStepIds.CreditCardInstallments,
  [CheckoutStepIds.CreditCardInstallments]: CheckoutStepIds.DataConfirmation,
  [CheckoutStepIds.DataConfirmation]: {
    [PaymentMethod.Pix]: CheckoutStepIds.PixBankSlip,
    [PaymentMethod.BankSlip]: CheckoutStepIds.PixBankSlip,
    [PaymentMethod.Card]: CheckoutStepIds.PaymentStatus,
  },
  [CheckoutStepIds.PixBankSlip]: CheckoutStepIds.PaymentStatus,
  [CheckoutStepIds.PaymentStatus]: null,
};

export const getNextStepId = (
  currentStepId: CheckoutStepIds,
  values: CheckoutFlowValues
): CheckoutStepIds | null => {
  const nextStep = nextStepById[currentStepId];

  if (typeof nextStep === 'string') return nextStep;
  if (nextStep === null) return null;

  const paymentMethodStep = values[CheckoutStepIds.PaymentMethod];

  return paymentMethodStep?.paymentMethod
    ? nextStep[paymentMethodStep.paymentMethod]
    : null;
};
